// extracted by mini-css-extract-plugin
module.exports = {"kudos":"kudos--2EPsnE","plus":"plus--Zfq9cE","minus":"minus--2Dh5J1"};